export default {
  cookiesAccepted(state, payload) {
    state.cookiesAccepted = payload.cookiesAccepted;
  },
  viewSingleReport(state, payload) {
    state.viewsinglereport = payload.viewsinglereport;
  },
  goToAcademy(_, paylaod) {
    window.open(paylaod.academyUrl);
  },
  goToCompany(_, paylaod) {
    window.open(paylaod.companyUrl);
  },
  goToFacebook(_, paylaod) {
    window.open(paylaod.facebookUrl);
  },
  goToInstagram(_, paylaod) {
    window.open(paylaod.instagramUrl);
  },
  goToLinkedin(_, paylaod) {
    window.open(paylaod.linkedinUrl);
  },
  goToTwitter(_, paylaod) {
    window.open(paylaod.twitterUrl);
  },
  goToMap(_, paylaod) {
    window.open(paylaod.mapUrl)
  },
  activeSelectedStudy(state,payload){
    state.activeSelectedStudy=payload.activeSelectedStudy
  }
};
